import { Input } from "@/src/components/universalInput";
import { ReorderableHospitalisationExams } from "./reorderableHospitalisationExams";
import { ReorderableHospitalisationEvolutions } from "./reorderableEvolutionsList";
import { Patient, SummaryData } from "@/src/data/allTypes";
import { useState } from "react";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";

function HospitalisationSummaryForm({
    patient,
    current,
    onChange,
  }: {
    patient: Patient;
    current: SummaryData;
    onChange: (newValue: SummaryData) => void;
  }) {
    let [data, setData] = useState(current || ({} as SummaryData));
    function setNewValue(newValue: SummaryData) {
      setData({ ...newValue });
      onChange({ ...newValue });
    }
  
    return (
      <div className="grid c1 gap30">
        <Input
          name={"Conclusion"}
          type={"textarea"}
          value={data.conclusion}
          placeholder="Texte libre..."
          rows={8}
          onChange={(newValue) => {
            setNewValue({ ...data, conclusion: newValue });
          }}
        />
  
        <div className="field">
          <div className="label">Examens à inclure</div>
          <ReorderableHospitalisationExams
            parent={data.item}
            currentValue={data.exams}
            onChange={(newValue) => {
              setNewValue({ ...data, exams: newValue });
            }}
          ></ReorderableHospitalisationExams>
        </div>
  
        <div className="field">
          <div className="label">Evènements</div>
          <ReorderableHospitalisationEvolutions
            patient={patient}
            parent={data.item}
            currentValue={data.evolutionItems}
            onChange={(newValue) => {
              setNewValue({ ...data, evolutionItems: newValue });
            }}
          ></ReorderableHospitalisationEvolutions>
        </div>
      </div>
    );
  }

  
export async function openHospitalisationSummaryForm({
    summaryData,
    patient,
    onChange,
  }: {
    summaryData: SummaryData;
    patient: Patient;
    onChange: (newValue: SummaryData) => void;
  }) {
    await openDrawer({
      id: "summaryForm",
      title: "Compte rendu",
      content: (
        <HospitalisationSummaryForm
          patient={patient}
          current={summaryData}
          onChange={(newValue) => {
            summaryData = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        closeDrawer("summaryForm");
        onChange(summaryData);
      },
    });
    return summaryData;
  }